import React, { useEffect, useState } from "react";
import cssClasses from "./TemplateMapping.module.css";
import { Box } from "@mui/material";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { groupBy, uniqBy } from "lodash";
import {
  getAllInventoryWithProjectDetails,
  getTemplateMappingByProjectId,
  insertDataForTemplateMapping,
  updateDataForTemplateMapping,
} from "../../Services/Inventory";
import { errorTost, successTost } from "../../Services/Toast";
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import {
  addProjectLogsForSdrPercent,
  getProjectByProjectId,
} from "../../Services/Project";
import axios from "axios";
import DropDown from "../../Subcomponents/DropDown";
import PreviewTemplateModal from "./PreviewTemplateModal";
import EmptyListIcon from "../../Assets/Images/Common/noProjectFound.svg";
import { useSelector } from "react-redux";
import { getAllPlansByProjectFromFarvision } from "../../Services/PaymentPlans";
import { getProjectByProjectName } from "../../Services/SustenanceService";

const TemplateMapping = ({ projectId }) => {
  let loggedInUser = useSelector((state) => state.Auth.user);
  const [inventoryData, setInventoryData] = useState([]);
  const [templateData, setTemplateData] = useState([]);
  const [selectedTemplateId, setSelectedTemplateId] = useState();
  const [previewTemplateModal, setPreviewTemplateModal] = useState(false);
  const [selectedTemplateData, setSelectedTemplateData] = useState();

  useEffect(() => {
    if (projectId) {
      setInventoryData([]);
      getProjectDetailsFromServer();
    }
  }, [projectId]);

  async function getProjectDetailsFromServer() {
    presentLoader();
    //Get BUID for Project
    await getProjectByProjectName(projectId)
      .then(async (projectResp) => {
        //get Payment plans for this project
        await getAllPlansByProjectFromFarvision(projectResp?.data?.[0]?.buId, projectResp?.data?.[0]?.isVJ)
          .then(async (getAllPlansByProjectResponse) => {
            let paymentPlans = [];
            if (
              getAllPlansByProjectResponse?.data &&
              getAllPlansByProjectResponse?.data?.result
            ) {
              paymentPlans = [...getAllPlansByProjectResponse?.data?.result];
            }
            //get Template data and map
            // await getAllInventoryWithProjectDetails(projectId)
            //   .then(async (resp) => {
            getTemplateMappingByProjectId(projectId)
              .then(async (mappingResp) => {
                const payload = [];
                paymentPlans.forEach((ele) => {
                  payload.push({
                    paymentPlanName: ele?.Description,
                    paymentPlanId: ele?.Id,
                    templateId:
                      mappingResp?.data?.filter(
                        (t) => t.paymentPlanId === ele?.Id
                      )?.length > 0
                        ? mappingResp?.data?.filter(
                          (t) => t.paymentPlanId === ele?.Id
                        )?.[0]?.templateId
                        : "",
                    templateName: mappingResp?.data?.filter(
                      (t) => t.paymentPlanId === ele?.Id
                    )?.length > 0
                      ? mappingResp?.data?.filter(
                        (t) => t.paymentPlanId === ele?.Id
                      )?.[0]?.templateName
                      : "",
                    isEdit:
                      mappingResp?.data?.filter(
                        (t) => t.paymentPlanId === ele?.Id
                      )?.length > 0
                        ? true
                        : false,
                  });
                });
                // console.log("payload", payload);
                setInventoryData(payload);
                await axios
                  .get(
                    `${process.env.REACT_APP_PAYMENT_LINK_URL}agreement/getTemplateData?reraNumber=${projectResp?.data?.[0]?.reraNumber}`
                  )
                  // .get(`http://localhost:8053/agreement/getTemplateData?reraNumber=${projectResp?.data?.[0]?.reraNumber}`)
                  .then((response) => {
                    dismissLoader();
                    if (!response?.data?.error) {
                      const templatePayload =
                        response.data?.data.filter(
                          (v) =>
                            v?.rera_no ===
                            projectResp?.data?.[0]?.reraNumber
                        );
                      // console.log("Template Payload", templatePayload);
                      setTemplateData(templatePayload);
                    } else {
                      console.log("err")
                      dismissLoader();
                      errorTost(response?.data?.error?.message);
                    }
                  })
                  .catch((err) => {
                    dismissLoader();
                    if (err?.message?.includes("Network Error")) {
                      errorTost("Error in backend api!");
                    } else {
                      errorTost(err.message);
                    }
                  });
              })
              .catch((err) => {
                dismissLoader();
                errorTost(err.message);
              });
          })
          .catch((err) => {
            dismissLoader();
            errorTost(err.message);
          });
        // })
        // .catch((err) => {
        //   console.log("err", err);
        //   dismissLoader();
        //   errorTost(err?.message);
        // });
      })
      .catch((err) => {
        dismissLoader();
        console.log("err", err);
        errorTost(err?.message);
      });
  }

  const handleSaveData = async () => {
    presentLoader();

    const insertPayload = inventoryData?.filter((v) => v?.isEdit === false);
    const editPayload = inventoryData?.filter((v) => v?.isEdit === true);

    if (editPayload?.length > 0) {
      for (const v of editPayload) {
        const payload = {
          templateName: v?.templateName,
          templateId: v?.templateId,
          // paymentPlanId : v?.paymentPlanId,
          last_updated_at: new Date().getTime(),
          inventorySubTypeId: null
        };
        await updateDataForTemplateMapping(payload, v?.paymentPlanId, projectId)
          .then(async (r) => {
            dismissLoader();
            let strArr = [];
            editPayload.forEach((v, index) =>
              strArr.push(`${v.type} from ${v?.templateId} to ${v?.templateId}`)
            );

            let logObj = {
              projectId: projectId,
              userId: loggedInUser?.userId,
              valueType: "Template Mapping Change",
              message: "Template Mapping changed for " + strArr.join() + ".",
            };
            await addProjectLogsForSdrPercent(logObj);
          })
          .catch((err) => {
            dismissLoader();
            errorTost(err.message);
          });
      }
      successTost("Template mapping updated successfully!")
      // getProjectDetailsFromServer();
    } 
    if(insertPayload?.length > 0) {
      for (const v of insertPayload) {
        const payload = {
          projectId: projectId,
          templateName: v?.templateName,
          templateId: v?.templateId,
          paymentPlanId: v?.paymentPlanId,
          inventorySubTypeId: null,
        };
        await insertDataForTemplateMapping(payload)
          .then(async (r) => {
            dismissLoader();
            let strArr = [];
            insertPayload.forEach((v, index) => {
              strArr.push(`${v.type} to ${v?.templateId}`);
            });

            let logObj = {
              projectId: projectId,
              userId: loggedInUser?.userId,
              valueType: "Template Mapping Change",
              message: "Template Mapping insert for " + strArr?.join() + ".",
            };
            await addProjectLogsForSdrPercent(logObj);
          })
          .catch((err) => {
            dismissLoader();
            errorTost(err.message);
          });
        }
        successTost("Template mapping inserted successfully!")
        // getProjectDetailsFromServer();
    }
    getProjectDetailsFromServer();
  };
  return (
    <div style={{ height: "100%" }}>
      <Box className={cssClasses.SubContainer}>
        <Box className={cssClasses.DivContainer}>
          <Box className={cssClasses.ProjectTitle}>Template Mapping</Box>
        </Box>
      </Box>
      <Box height={"95%"} overflow={"auto"}>
        <Box
          display={"flex"}
          flexDirection={"column"}
          height={"100%"}
          justifyContent={"space-between"}
        >
          {inventoryData?.length > 0 ? (
            <Box
              display={"flex"}
              flexDirection={"column"}
              gap={"1rem"}
              marginBottom={"2rem"}
              width={"100%"}
            >
              {inventoryData?.map((v, index) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "end",
                      borderRadius: "1rem",
                    }}
                  >
                    <div style={{ width: "50%" }}>
                      <CustomInput
                        disabled={true}
                        label={`${index === 0 ? "Payment Plan" : ""}`}
                        placeholder={v?.paymentPlanName}
                        inputType={"string"}
                      />
                    </div>
                    <div style={{ width: "10%" }}>
                      <DropDown
                        onChangeSelect={(e) => {
                          const payload = [...inventoryData];
                          const selectedTemp = templateData?.filter(
                            (v) => v?.template_id === e
                          );
                          payload[index].templateId = e;
                          payload[index].templateName =
                            selectedTemp[0]?.template_name;
                          payload[index].templateType =
                            selectedTemp[0]?.template_type;
                          setInventoryData(payload);
                          setSelectedTemplateId(e);
                        }}
                        selectedValue={v?.templateId}
                        style={{
                          selectedColor: "#175CD3",
                          background: "#E8F0FE",
                        }}
                        list={templateData?.map((v) => {
                          return v?.template_id;
                        })}
                        label={`${index === 0 ? "Template Id" : ""}`}
                      />
                    </div>
                    <div style={{ width: "30%" }}>
                      <CustomInput
                        disabled={true}
                        label={`${index === 0 ? "Template Name" : ""}`}
                        placeholder={v?.templateName}
                        inputType={"text"}
                      />
                    </div>
                    {/* <div style={{ width: "10%" }}>
                      <Button
                        style={{
                          fontSize: "1.6rem",
                          lineHeight: "2.4rem",
                          color: "#155EEF",
                          backgroundColor: "rgba(235, 245, 255, 1)",
                          borderRadius: "0.8rem",
                          width: "100px",
                        }}
                        padding={"0.8rem 2.6rem"}
                        btnName={"Preview"}
                        disable={v?.templateId === ""}
                        clicked={() => {
                          setPreviewTemplateModal(true);
                          setSelectedTemplateData(inventoryData[index]);
                        }}
                      />
                    </div> */}
                  </div>
                );
              })}
            </Box>
          ) : (
            <div className={cssClasses.noDataWrapper}>
              <div className={cssClasses.noDataMsg}>
                <div className={cssClasses.emptyIcon}>
                  <img src={EmptyListIcon} alt="No Records" />
                </div>
                <div className={cssClasses.emptyTitle}>
                  No Records Available!
                </div>
              </div>
            </div>
          )}
          {inventoryData?.length > 0 && (
            <Box display={"flex"} justifyContent={"end"} width={"100%"}>
              <Button
                style={{
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                  color: "#fff",
                  backgroundColor: "rgb(21, 112, 239)",
                  borderRadius: "0.8rem",
                  width: "180px",
                }}
                padding={"0.8rem 2.6rem"}
                btnName={"Save Changes"}
                disable={inventoryData?.filter((v) => v?.templateId === "")?.length > 0}
                clicked={() => {
                  handleSaveData();
                }}
              />
            </Box>
          )}
        </Box>
      </Box>
      {previewTemplateModal && (
        <PreviewTemplateModal
          open={previewTemplateModal}
          handleClose={() => {
            setPreviewTemplateModal(false);
          }}
          selectedTempleteData={selectedTemplateData}
        />
      )}
    </div>
  );
};

export default TemplateMapping;
